// removed by extract-text-webpack-plugin
module.exports = {"black":"#333333","blackContrast":"#ffffff","white":"#ffffff","whiteContrast":"#333333","primaryColor":"#008573","primaryContrast":"#ffffff","lightGray":"#f4f4f4"};